import React from 'react';

const ErrorNotice = (props) => {
  const { message, style, className } = props;
  return (
    <div style={style} className={className}>
      <span>{message}</span>
    </div>
  );
};

ErrorNotice.defaultProps = {
  message: 'Something wrong! Please try again!',
  style: {
    color: 'red',
  },
};

export default ErrorNotice;
